export default __webpack_public_path__ + "static/MultipleOwners-8dd597a8f09f7d13289bbaee667daea6.svg";